import React, { useState } from 'react'
import withStyles from '@mui/styles/withStyles'
import { ListItem } from '@mui/material'
import { ActiveContractNotificationModel } from '../../'
import axios from 'axios'
import CustomCircularProgress from '../../../../smallComponents/CustomCircularProgress'
import IssueNotificationModel from './ContractNotifListItemComponents/IssueNotificationModel'

const styles = () => ({
  listItem: {
    display: 'flex',
    flexDirection: 'row',
    width: '100% !important',
    alignContent: 'center !important',
    alignItems: 'center !important',
    cursor: 'pointer !important',
    '&:hover': {
      opacity: '0.8',
    },
  },
  clickedNotification: {
    backgroundColor: 'rgba(217,224,252, 0.6) !important',
    cursor: 'pointer !important',
  },
})

const ContractNotifListItem = ({
  classes,
  props,
  element,
  toastDisabledFun,
}) => {
  const {
    isDarkModeActive,
    setChosenNotification,
    chosenNotification,
    sender,
    project,
    // defined only for m view
    senders,
    projects,
    socket,
    // this function is for the m version
    notificationDialogOpener,
    setDealsNotifications,
  } = props

  const [notification, setNotification] = useState(element)
  const senderII = senders?.find(
    (se) => se._id === notification.accompaniedData?.senderId
  )
  const projectII = projects?.find(
    (pro) => pro._id === notification.accompaniedData.projectId
  )
  const notifProps = {
    notification,
    isDarkModeActive,
    sender: senderII ? senderII : sender,
    project: projectII ? projectII : project,
    socket,
  }

  const notifModels = [
    {
      associativity: 'activeContract',
      component: <ActiveContractNotificationModel notifProps={notifProps} />,
    },
    {
      associativity: 'issue',
      component: <IssueNotificationModel notifProps={notifProps} />,
    },
  ]
  return (
    <ListItem
      className={
        element?._id === chosenNotification?._id
          ? classes.clickedNotification
          : classes.listItem
      }
      onClick={async () => {
        if (notification._id && !toastDisabledFun) {
          try {
            const res = await axios.patch(
              `/notifications/${notification._id}`,
              {
                opened: true,
                shown: true,
              }
            )
            setNotification(res.data.notification)
            setDealsNotifications((notifs) => {
              let oldIndex = notifs?.findIndex(
                (n) => n._id === notification._id
              )
              return notifs.map((p, i) =>
                i === oldIndex ? res.data.notification : p
              )
            })
          } catch (error) {
            console.log(error)
          }
        }
        if (typeof setChosenNotification === 'function')
          setChosenNotification(element)
        if (typeof notificationDialogOpener === 'function')
          notificationDialogOpener()
      }}
      style={{
        color: isDarkModeActive ? 'white' : null,
      }}
    >
      {(sender ? !sender : !senderII) ? (
        <CustomCircularProgress />
      ) : (
        notifModels.find(
          (notif) => notif?.associativity === notification?.associativity
        )?.component
      )}
    </ListItem>
  )
}

const WrappedContractNotifListItem = withStyles(styles)(ContractNotifListItem)

export default WrappedContractNotifListItem
